import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class CookieService {

  constructor(@Inject(DOCUMENT) private document: Document) { }

  getCookie(name: string): string {
    const cookies = this.document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }

  setCookie(name: string, value: string, expirationDays: number): void {
    const date = new Date();
    date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    this.document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  deleteCookie(name: string): void {
    this.setCookie(name, '', -1);
  }
}
